import React from "react";

import RadioStar from "./RadioStar";

type Props = {
  className?: string;
  errorMessage?: string;
  initialRating?: number;
  name?: string;
  onSetRating: (rating: number) => void;
  starSize?: number;
  legend?: string;
  legendClassName?: string;
};

const InteractiveStarRating: React.FC<Props> = ({
  className,
  errorMessage,
  initialRating = 0,
  name,
  onSetRating,
  starSize = 24,
  legend,
  legendClassName,
}) => {
  const [rating, setRating] = React.useState<number>(initialRating);

  const setNewRating = (newRating: number) => {
    setRating(newRating);
    onSetRating(newRating);
  };

  return (
    <fieldset
      // For keyboard nav, when you first focus into the component, select the first star.
      // otherwise, you have to hit right-arrow to select 2 stars then come back to select 1.
      onFocus={() => {
        rating || setRating(1);
      }}
      className={className}
    >
      {legend && (
        <legend className={legendClassName ?? "font-bold mb-md"}>
          {legend}
        </legend>
      )}
      <div className="flex radioStars">
        {Array(5)
          .fill(1)
          .map((_, i) => (
            <RadioStar
              key={`star-${i}`}
              name={`${name} rating`}
              value={i + 1}
              filled={rating > i}
              onChange={setNewRating}
              starSize={starSize}
            />
          ))}
      </div>
      {errorMessage && <div className="text-xs text-error">{errorMessage}</div>}
    </fieldset>
  );
};

export default InteractiveStarRating;
